// WelcomeHelper
import React from 'react';
import { connect } from 'react-redux';

import DomImage from './DomImage';
import Moment from 'moment';
import MomentTZ from 'moment-timezone';
import _ from 'lodash';
import { getTranslator } from '../locales';

@connect((Store) => {
  const t = getTranslator();
  const chat = Store.chat;
  const luser = Store.luser;

  return {
    labels: {
      ASK_A_NEW_QUESTION: t.t('Ask a new question'),
      CHAT_TIMES: t.t(
        'from %{start_time} to %{end_time}',
        {
          'start_time': MomentTZ(chat.startDate).tz(chat.timeZoneName).format('LT'),
          'end_time': MomentTZ(chat.endDate).tz(chat.timeZoneName).format('LT')
        }
      ),
      LUSER_WELCOME: t.t(
        'Welcome %{user_firstname}',
        { 'user_firstname': _.upperFirst(luser.firstname) }
      ),
      OR: t.t('OR'),
      POST_A_MESSAGE_TO_EVERYONE_TO_INTRODUCE_YOURSELF: t.t('Say hello, introduce yourself as an Insider'),
      SELL_ALL_DISCUSSIONS: t.t('Access current discussions'),
    },
    chat,
    luser
  }
})

export default class WelcomeHelper extends React.Component {

  handdleToggleInsiderForm() {
    this.props.mobilePanelChange('insider_form');
  }

  handdleMessagesPanel() {
    this.props.mobilePanelChange('threads');
  }

  render() {
    return (
      <div className={this.props.mobilePanelClassName('welcomehelper') + ' messages brandedColorLight_bg'}>
        <h1 className='brandedColor_bg'>{this.props.labels.LUSER_WELCOME}</h1>
        <div className='inner-content'>
          <h2>
            {_.upperFirst(this.props.chat.title)}
          </h2>
          <h3 className='brandedColor_color'>
          {this.props.labels.CHAT_TIMES}
          {
            (() => {
              if (this.props.chat.logoUrl) {
                return <DomImage src={this.props.chat.logoUrl} className='logo' />
              }
            })()
          }
          </h3>
          <div className='description' dangerouslySetInnerHTML={{__html: this.props.chat.description}}></div>
          {
            (() => {
              if (!this.props.luser.insider){
                return <div className='actions visitor'>
                  <button className='btn btn-primary btn-round brandedColor_bg brandedColorLight_border' value='+' onClick={this.props.handleClickToggleQuestionForm.bind(this)} >
                    <i className="pe-7s-comment"></i>
                    <i className="pe-7s-plus brandedColor_bg "></i>
                  </button>
                  <button className='btn btn-primary btn-text brandedColor_bg brandedColorLight_border' value='+' onClick={this.props.handleClickToggleQuestionForm.bind(this)} >
                    {this.props.labels.ASK_A_NEW_QUESTION}
                  </button>

                  <span className='or'>{this.props.labels.OR}</span>
                  <button className='btn btn-secondary' value='+' onClick={this.handdleMessagesPanel.bind(this)} >
                    {this.props.labels.SELL_ALL_DISCUSSIONS}
                  </button>
                </div>
              } else {
                return <div className='actions insider'>
                  <button className='btn btn-primary btn-round brandedColor_bg brandedColorLight_border' value='+' onClick={this.handdleToggleInsiderForm.bind(this)} >
                    <i className='pe-7s-speaker'></i>
                  </button>
                  <button className='btn btn-primary btn-text brandedColor_bg brandedColorLight_border' value='+' onClick={this.handdleToggleInsiderForm.bind(this)} >
                    {this.props.labels.POST_A_MESSAGE_TO_EVERYONE_TO_INTRODUCE_YOURSELF}
                  </button>

                  <span className='or'>{this.props.labels.OR}</span>
                  <button className='btn btn-secondary' onClick={this.handdleMessagesPanel.bind(this)} >
                    {this.props.labels.SELL_ALL_DISCUSSIONS}
                  </button>
                </div>
              }
            })()
          }
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/WelcomeHelper.jsx